import React from 'react';

import cn from 'classnames';
import type { DateTime } from 'luxon';
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';
import { DatePicker } from 'scouting-ui/lib';

import { getCalendarMinMaxRange } from '@shared/utils/calendarMinMaxRange';

import Button from '../Button';
import S from '../S';
import { Col, Row } from '../bsaComponents';
import styles from './CalendarDateHeader.less';

const { RangePicker } = DatePicker;

type customRangeType = [
  start: DateTime<boolean> | null | undefined,
  end: DateTime<boolean> | null | undefined,
];

interface Props {
  handleLeft?: VoidFunction;
  handleRight?: VoidFunction;
  handleRange?: (
    dates: null | (DateTime | null)[],
    dateStrings: [string, string],
  ) => void;
  leftSpan?: number;
  rightHeader?: React.ReactElement;
  title?: string;
  className?: string;
  selectedRangeDate?: null | (DateTime | null)[];
  showRange?: boolean;
}

const { min, max } = getCalendarMinMaxRange();

const CalendarDateHeader: React.FC<Props> = ({
  handleLeft = () => {},
  handleRight = () => {},
  handleRange,
  leftSpan = 22,
  rightHeader,
  title,
  className,
  selectedRangeDate,
  showRange,
}) => {
  const spanChild = 24 - leftSpan;

  return (
    <Row className={cn(styles.controlsWrapper, className)}>
      <Col
        span={rightHeader ? leftSpan : 24}
        className="d-flex items-center"
        xs={rightHeader ? undefined : 12}
      >
        <Button
          ghost
          noBorder
          fitText
          className={styles.arrowButton}
          onClick={handleLeft}
        >
          <MdNavigateBefore />
        </Button>
        <S size="3" colored className={styles.titleFormat}>
          {title}
        </S>
        <Button
          ghost
          noBorder
          fitText
          className={styles.arrowButton}
          onClick={handleRight}
        >
          <MdNavigateNext />
        </Button>
      </Col>
      {rightHeader && <Col span={spanChild}>{rightHeader}</Col>}
      {showRange && (
        <Col className={styles.rangeCol} xs={12}>
          <div className={styles.rangeContainer}>
            <RangePicker
              size="small"
              format={'MM/dd/yyyy'}
              value={selectedRangeDate as customRangeType}
              minDate={min}
              maxDate={max}
              onChange={handleRange}
            />
          </div>
        </Col>
      )}
    </Row>
  );
};

export default CalendarDateHeader;
